export function elementYPosition(element: HTMLElement): number {
  if (!element) return 0;
  if (element.offsetParent === <any>element.ownerDocument) return element.offsetTop;

  return element.offsetTop + elementYPosition(element.offsetParent as HTMLElement);
}
